import { render, staticRenderFns } from "./QuizGenerateBgModal.vue?vue&type=template&id=23b69c58&"
import script from "./QuizGenerateBgModal.vue?vue&type=script&lang=js&"
export * from "./QuizGenerateBgModal.vue?vue&type=script&lang=js&"
import style0 from "./QuizGenerateBgModal.vue?vue&type=style&index=0&id=23b69c58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../backend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports